import { Route, Routes, Navigate } from 'react-router-dom';
import LoadingPage from './pages/loadingPage/LoadingPage';
import Load from './pages/loadingPage/Load';
import UserLayout from './layout/UserLayout';
import OrgLayout from './layout/OrgLayout';
import SupportLayout from './layout/SupportLayout';
import { OrgAuthProvider } from './context/OrgAuthContext';
import { SupAuthProvider } from './context/SupAuthContext';
import { ToastContainer } from 'react-toastify';
import { TempOrgProvider } from './context/TempOrgContext';
import { useEffect } from 'react';
import HostLayout from './layout/HostLayout';
import { OrganizerProvider } from './host/context/OrganizerContext';
import OrgActivityLayout from './layout/OrgActivityLayout';
import OrgCampLayout from './layout/OrgCampLayout';
import OrgGuidLayout from './layout/OrgGuidLayout';
import OrgBaseLayout from './layout/OrgBaseLayout';

function App() {
    const isMobile = window.innerWidth < 768;
    useEffect(() => {
        const disableScrollOnInputNumber = (event) => {
            const activeElement = document.activeElement;
            if (activeElement && activeElement.type === 'number') {
                activeElement.blur();
            }
        };
        window.addEventListener('wheel', disableScrollOnInputNumber, { passive: false });
        return () => {
            window.removeEventListener('wheel', disableScrollOnInputNumber);
        };
    }, []);

    return (
        <>
            <Routes>
                <Route
                    path='/*'
                    element={
                        <TempOrgProvider>
                            <UserLayout />
                        </TempOrgProvider>
                    }
                />
                <Route path='*' element={<Navigate to='/' />} />
                <Route
                    path='/org'
                    element={
                        <OrgAuthProvider>
                            <OrgBaseLayout />
                        </OrgAuthProvider>
                    }
                >
                    <Route path='*' element={<OrgLayout />} />
                    <Route path='a/*' element={<OrgActivityLayout />} />
                    <Route path='c/*' element={<OrgCampLayout />} />
                    <Route path='g/*' element={<OrgGuidLayout />} />
                </Route>
                <Route
                    path='/support/:mode?/*'
                    element={
                        <SupAuthProvider>
                            <SupportLayout />
                        </SupAuthProvider>
                    }
                />
                <Route
                    path='/h/*'
                    element={
                        <OrganizerProvider>
                            <HostLayout />
                        </OrganizerProvider>
                    }
                />
                <Route path='/loading' element={<LoadingPage />} />
                <Route path='/load' element={<Load />} />
            </Routes>
            {/* </OrgAuthProvider> */}
            <p className='developer'>Developed by Sagar Bazar</p>
            <ToastContainer
                autoClose={3000}
                hideProgressBar={isMobile ? true : false}
                position={'top-right'}
                newestOnTop={false}
                theme={isMobile ? 'dark' : 'light'}
                closeOnClick
                closeButton={isMobile ? false : true}
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}

export default App;
